// The same standard Google tag pair for every project; IDs come from its admin.
export function googleMeasurementIds(value) {
    if (typeof value !== 'string') return [];
    return [...new Set((value.match(/\b(?:G|GT)-[A-Z0-9]{4,27}\b/gi) || []).map(id => id.toUpperCase()))];
}

export function installGoogleAnalytics(value, documentRef = document) {
    const ids = googleMeasurementIds(value);
    if (!ids.length || !documentRef?.head) return [];
    const src = `https://www.googletagmanager.com/gtag/js?id=${ids[0]}`;
    if (documentRef.querySelector(`script[src="${src}"]`)) return ids;
    const loader = documentRef.createElement('script');
    loader.async = true;
    loader.src = src;
    const bootstrap = documentRef.createElement('script');
    const nonce = documentRef.querySelector('meta[name="ga-nonce"]')?.content;
    if (nonce) bootstrap.nonce = nonce;
    bootstrap.textContent = [
        '  window.dataLayer = window.dataLayer || [];',
        '  function gtag(){dataLayer.push(arguments);}',
        "  gtag('js', new Date());",
        '',
        ...ids.map(id => `  gtag('config', '${id}');`),
    ].join('\n');
    documentRef.head.append(loader, bootstrap);
    return ids;
}
